import React from 'react';
import { Box } from '@mui/material';
import cvLogoBlanco from '../../../../../assets/cv-logo-blanco.png';
import cvLogoNegro from '../../../../../assets/cv-logo-negro.png';

interface LogoProps {
  variant?: 'white' | 'black';
  height?: number;
}

export const Logo: React.FC<LogoProps> = ({ 
  variant = 'white', 
  height = 50 
}) => {
  const logoSrc = variant === 'white' ? cvLogoBlanco : cvLogoNegro;

  return (
    <Box
      component="img"
      src={logoSrc}
      alt="CV Printing Logo"
      sx={{
        height: `${height}px`,
        width: 'auto',
        objectFit: 'contain',
      }}
    />
  );
}; 